const API = process.env.REACT_APP_BACKEND_URL || "";

async function request(path, options = {}) {
  const response = await fetch(`${API}/api/calendar-v2${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body?.detail?.reason || body?.detail || "Calendar request failed");
    error.status = response.status;
    error.payload = body;
    throw error;
  }
  return body;
}

export const calendarV2Api = {
  day: (date) => request(`/day/${date}`),
  pattern: () => request("/pattern"),
  pupils: () => request("/pupils"),
  planBooking: (payload) => request("/booking/plan", {
    method: "POST",
    body: JSON.stringify(payload),
  }),
  commitBooking: (payload) => request("/booking/commit", {
    method: "POST",
    body: JSON.stringify(payload),
  }),
  changeSpace: ({ date, original, changed }) => request("/space/commit", {
    method: "POST",
    body: JSON.stringify({
      date,
      original_start: original.start,
      original_end: original.end,
      start: changed.start,
      end: changed.end,
    }),
  }),
  proposeRepeat: (payload) => request("/repeat/propose", {
    method: "POST",
    body: JSON.stringify(payload),
  }),
  commitRepeat: (payload) => request("/repeat/commit", {
    method: "POST",
    body: JSON.stringify(payload),
  }),
};
